<template>
  <span v-if="logs && logs.length" class="suggestion-match-log-info">
    <v-btn
      id="suggestion_match_log_info"
      icon
      variant="text"
      size="small"
      :aria-label="$t('annotate.suggestion_log_title')"
      @click="open = true"
    >
      <v-icon size="small">mdi-information-outline</v-icon>
    </v-btn>
    <v-dialog v-model="open" max-width="800">
      <v-card>
        <v-card-title>{{ $t('annotate.suggestion_log_title') }}</v-card-title>
        <v-card-subtitle>{{ $t('annotate.suggestion_log_subtitle') }}</v-card-subtitle>
        <v-card-text>
          <div
            v-for="log in logs"
            :key="log.model_id"
            class="mb-4"
          >
            <div class="text-subtitle-2 mb-1">
              {{ log.model_name || $t('annotate.suggestion_log_unknown_model') }}
              <span class="text-medium-emphasis">(model {{ log.model_id }})</span>
            </div>
            <pre class="suggestion-match-log-info__pre">{{ log.log_text }}</pre>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="open = false">{{ $t('annotate.suggestion_log_close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  name: 'SuggestionMatchLogInfo',
  props: {
    logs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      open: false,
    };
  },
};
</script>

<style scoped>
.suggestion-match-log-info {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}
.suggestion-match-log-info__pre {
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 12px;
  line-height: 1.45;
  margin: 0;
  padding: 12px;
  background: rgba(0, 0, 0, 0.04);
  border-radius: 4px;
  max-height: 420px;
  overflow: auto;
}
</style>
